import React from 'react';

import { Card, FormItem } from '../../../components';
import { Input } from '../../../components/Input';
import type { AgentForm as AgentFormType } from '../../../utilities';
import { validateGreetingsObjectString } from '../utils/validateGreetings';

export type CorporateAgentSettingsProps = {
  form: AgentFormType;
  disabled?: boolean;
};

const CorporateAgentSettings: React.FC<CorporateAgentSettingsProps> = ({
  form,
  disabled,
}) => {
  return (
    <div className="flex flex-col gap-y-md">
      {/* Corporate Agent Settings */}
      <Card
        collapsable
        size="unset"
        title="Corporate Agent Settings"
        name="agentpage.Corporate Agent Settings"
        contentClassName="flex flex-col gap-y-md"
        subtitle="Configure corporate-specific agent settings"
      >
        <FormItem<AgentFormType>
          name="agent_preset_greetings"
          label="Agent Preset Greetings"
          validate={validateGreetingsObjectString}
        >
          <Input
            multiline
            disabled={disabled}
            placeholder={`
                          Format: {label: "greeting1", text: "Hello! Welcome!"};
                          {label: "greeting2", text: "Hi there! How can I help?"};
                          Each greeting should have both 'label' and 'text' properties.
                        `}
          />
        </FormItem>
      </Card>
    </div>
  );
};

export default React.memo(
  CorporateAgentSettings
) as typeof CorporateAgentSettings;
